export default __webpack_public_path__ + "static/intro_elements_B3_desktop-2f380948bd495cf54fc640b4afbb755b.jpg";